
    import {defineComponent, toRefs, reactive} from 'vue'

    interface State {
        data: object;
        isShowModel: boolean;
    }

    export default defineComponent({
        name: "componentModel",
        props: {
            showModel: {
                type: Boolean,
                default: false,
            },
            data: {
                type: Object,
                default: () => {
                    return {}
                },
            },
        },
        setup(props: any) {
            let state: State = reactive({
                data: {},
                isShowModel: false,
            })
            const {showModel,data} = toRefs(props)
            state.data = data.value
            state.isShowModel = showModel
            return {
                state
            }
        },
        methods: {
            hiddenModel(){
                this.state.isShowModel = false
                this.$emit("parEvn", false)
            }
        }
    })
